import session from './sessionReducer';
import nav from './navReducer';
import app from './appReducer';
import notify from './notifyReducer';
import intl from './intlReducer';
import jestTest from './jestReducer';
import environmentalSocialGovernance from './esgReducer';
import environmentalSocialGovernanceHome from './esgReducer';
import environmentalSocialGovernanceHistory from './esgReducer';

const redux = {
	app,
	intl,
	notify,
	nav,
	session,
	jestTest,
	environmentalSocialGovernance,
	environmentalSocialGovernanceHome,
	environmentalSocialGovernanceHistory
};

export default redux;

